import { onMounted } from 'vue'
import { useNuxtApp, useRoute, useRuntimeConfig } from '#app'

import { useToggleStore } from '~/store/toggle/toggle'
import { useUserStore } from '~/store/user/user'

import { VkAuthService } from '@/services/vkAuth/vkAuthService'
import { authByVk } from '@/services/vkAuth/vkAuthCallback'
import { VkAuthType } from '@/services/vkAuth/vkAuth.types'

export default function (type: VkAuthType) {
  const { $sentryCaptureException } = useNuxtApp()
  const { path } = useRoute()

  const userStore = useUserStore()
  const { VK_TOKEN } = useRuntimeConfig().public
  const {
    featureToggle: { auth_by_vk_id_enabled },
  } = useToggleStore()

  const vkAuthService = new VkAuthService()

  onMounted(() => {
    if (!auth_by_vk_id_enabled || userStore.isAuthenticated) return

    const initResult = vkAuthService.init(Number(VK_TOKEN))

    if (initResult instanceof Error) {
      $sentryCaptureException(initResult)
    }

    if (type === VkAuthType.BUTTON) {
      oneTapButtonInit()

      return
    }

    floatingButtonInit()
  })

  const oneTapButtonInit = () =>
    vkAuthService.authByOneTapButton(authByVk, window.location.origin)

  const floatingButtonInit = () =>
    vkAuthService.authByFloatingButton(authByVk, window.location.origin + path)

  const setVkFrame = (blockForVkButton: Node) => {
    vkAuthService.setIframe(blockForVkButton)
  }

  return {
    setVkFrame,
  }
}
